import React, { useEffect, useState } from "react";
import { Button, Row } from "reactstrap";

import { DotPulse } from "@uiball/loaders";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LoadMoreCourses } from "../../store/actions/HolesAction";

/*
    Search pages for a state and for a city in it. Both take the state as the
    course record carries it (an abbreviation such as "AL" or "ON"), which is
    what the backend's /city and /courses filters accept.
*/
const statePath = (state) => `/courses/search/${encodeURIComponent(state)}`;
const cityPath = (state, city) =>
  `${statePath(state)}/${encodeURIComponent(city)}`;

// The course page, carrying the row so it can render before its own fetch.
const coursePage = (course) => ({
  pathname: `/courses/holes/${course.id}`,
  state: { course },
});

function CoursesTable({ courseData }) {
  const dispatch = useDispatch();
  const { quickSearch, courseLoader } = useSelector((state) => state.course);
  const [courseCount, setCoursesCount] = useState(courseData?.length);

  useEffect(() => {
    setCoursesCount(courseData?.length);
  }, [quickSearch]);

  return (
    <>
      {/* {loader ? (
                <div className="vh-100 d-flex justify-content-center align-items-center">
                    <Spinner> </Spinner>
                </div>
            ) : (
                <> */}
      <Row className="px-md-0 mx-0 px-0 mt-5" style={{ overflowX: "scroll" }}>
        <table className="table table-hover mb-0 fs--14">
          <thead>
            <tr>
              {/* <th scope="col">#</th> */}
              <th scope="col" style={{ minWidth: 200 }}>
                Course Name
              </th>
              <th scope="col">City</th>
              <th scope="col">State / Province / Region</th>
              <th scope="col">Country</th>
              <th scope="col">Maps</th>
            </tr>
          </thead>
          <tbody>
            {courseData && courseData.length > 0 ? (
              courseData?.map((item, id) => (
                <tr key={id}>
                  {/* <td
                                            scope="row"
                                            className="align-middle fs--14"
                                        >
                                            {id + 1}
                                        </td> */}
                  <td className="align-middle text-site-primary link-hover fs--15 fw--600">
                    <div>
                      <Link to={coursePage(item)} className="custom-a-hover">
                        {item.name}
                      </Link>
                    </div>
                    <div className="text-muted fs--12">
                      {item?.address?.street}
                    </div>
                  </td>
                  <td className="fs--14 align-middle">
                    {item?.address?.state && item?.address?.city ? (
                      <Link
                        to={cityPath(item.address.state, item.address.city)}
                        className="custom-a-hover"
                      >
                        {item.address.city}
                      </Link>
                    ) : (
                      <span className="text-muted">{item?.address?.city}</span>
                    )}
                  </td>
                  <td className="fs--14 align-middle">
                    {item?.address?.state ? (
                      <Link
                        to={statePath(item.address.state)}
                        className="custom-a-hover"
                      >
                        {item.address.state}
                      </Link>
                    ) : null}
                  </td>
                  <td className="fs--14 text-muted align-middle">
                    {item?.address?.country}
                  </td>
                  <td className="fs--14 align-middle text-site-primary">
                    {item?.isMapAvailable ? (
                      <Link to={coursePage(item)} className="custom-a-hover">
                        Available
                      </Link>
                    ) : (
                      // Still links to the course,
                      // for its address and
                      // scorecard, but stays gray:
                      // there is no map to offer.
                      <Link to={coursePage(item)} className="text-muted">
                        Not Available
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td></td>
                <td>No Course Found</td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
      </Row>{" "}
      <div className="text-center">
        {courseCount != 0 && !(courseCount < 25) && (
          <Button
            disabled={courseLoader}
            size="md"
            className="bg-light text-site-muted shadow-sm border-0 my-2"
            onClick={(event) => {
              dispatch(
                LoadMoreCourses(
                  {
                    ...quickSearch,
                    marker: courseData[courseData.length - 1]?.id,
                  },
                  (count) => {
                    setCoursesCount(count);
                  }
                )
              );
            }}
          >
            {courseLoader ? (
              <DotPulse size={25} speed={1.3} color="white" />
            ) : (
              "Load More"
            )}
          </Button>
        )}
      </div>
      {/* </>
            )} */}
    </>
  );
}

export default CoursesTable;
